const freeFeatures = ["Basic molecular views", "Basic editing features"];
const plusFeatures = [
  "Load from RCSB, PubChem, Drugbank, or your files from your desktop",
  "Host or join a password protected room",
  "Save VR workspaces",
  "Assign presenter & block users",
  "Export molecules in PDB/SDF format"
];
const eduFeatures = [
  "Play Trajectory Animations",
  "Multi SDF Ligand support",
  "Electron Density Map Support (CCP4 & DSN6)"
];
const enterpriseFeatures = [
  "Dedicated secure collaboration server",
  "Plugin server deployment",
  "Plugin integration support",
  "Offline mode",
  "Internal database integration",
  "Custom development",
  "Premium customer support"
];
const otherFeatures = {
  personal: [
    "Host public workspaces",
    "Join public workspaces",
    "Load structures from RCSB",
    "Load up to 2 molecules"
  ],
  edu: ["Load unlimited molecules"]
};
const eduBundleFeatures = [
  ...plusFeatures,
  ...eduFeatures,
  ...otherFeatures.edu,
  "Create active learning environments",
  "Increase student motivation",
  "Increase student engagement and retention of class material"
];

export default {
  available: {
    edu: "edu-26"
  },
  free: {
    name: "Personal",
    icon: "icon-star",
    img: "/static/img/nanome-personal.svg",
    features: [...freeFeatures, ...otherFeatures.personal],
    shortFeatures: [...freeFeatures, ...otherFeatures.personal]
  },
  plus: {
    name: "Plus",
    icon: "icon-badge",
    img: "/static/img/nanome-plus.svg",
    features: [...freeFeatures, ...plusFeatures],
    shortFeatures: ["Includes everything in Personal", ...plusFeatures],
    discountedFrom: 19900
  },
  pro: {
    name: "Pro",
    icon: "icon-trophy",
    img: "/static/img/nanome-professional.svg",
    features: [...freeFeatures, ...plusFeatures, ...eduFeatures],
    shortFeatures: ["Includes everything in Plus", ...eduFeatures]
  },
  edu: {
    name: "Academic",
    icon: "icon-graduation",
    img: "/static/img/nanome-academic.svg",
    description:
      "Leverage advanced scientific-grade software with native collaboration for your classroom.",
    features: [
      ...freeFeatures,
      ...plusFeatures,
      ...eduFeatures,
      ...otherFeatures.edu
    ],
    shortFeatures: [...plusFeatures, ...eduFeatures, ...otherFeatures.edu],
    discountedFrom: 29900
  },
  "edu-bundle": {
    name: "Academic",
    bundleName: "Classroom",
    bundleOf: "edu",
    discountedFrom: 375000,
    features: [...freeFeatures, ...eduBundleFeatures],
    shortFeatures: eduBundleFeatures
  },
  trial: {
    name: "Trial",
    icon: "icon-star",
    img: "/static/img/nanome-trial.svg"
  },
  enterprise: {
    id: "enterprise",
    icon: "icon-diamond",
    img: "/static/img/nanome-enterprise.svg",
    type: "enterprise",
    details: {
      name: "Commercial",
      shortFeatures: ["Includes everything in Academic", ...enterpriseFeatures]
    }
  }
};
